import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Error403 = () => {
 const navigate = useNavigate();

 useEffect(() => {
 Swal.fire({
 title: "Restricted Access",
 text: "You currently don't have access to this feature. Please contact your administrator if access is required.",
 icon: "info",
 confirmButtonText: "OK",
 confirmButtonColor: "#3085d6",
 });
 }, []);

 return (
 <div className="authincation h-100">
 <div className="container h-100">
 <div className="row justify-content-center h-100 align-items-center ">
 <div className="col-md-5">
 <div className="form-input-content text-center error-page">
 <h1 className="error-text fw-bold">403</h1>
 <h4>
 <i className="fa fa-info-circle text-primary" />{" "}
 Restricted Access
 </h4>
 <p>You currently don't have access to this feature. Please contact your administrator if access is required.</p>
 <div className="d-flex justify-content-center gap-3 mt-4">
 <button 
 className="btn btn-primary" 
 onClick={() => navigate(-1)}
 >
 Go Back
 </button>
 <Link className="btn btn-secondary" to="/dashboard">
 Back to Home
 </Link>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 );
};

export default Error403;
